"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EppoValue = exports.EppoValueType = void 0;
const interfaces_1 = require("./interfaces");
const obfuscation_1 = require("./obfuscation");
var EppoValueType;
(function (EppoValueType) {
    EppoValueType[EppoValueType["NullType"] = 0] = "NullType";
    EppoValueType[EppoValueType["BoolType"] = 1] = "BoolType";
    EppoValueType[EppoValueType["NumericType"] = 2] = "NumericType";
    EppoValueType[EppoValueType["StringType"] = 3] = "StringType";
    EppoValueType[EppoValueType["JSONType"] = 4] = "JSONType";
})(EppoValueType || (exports.EppoValueType = EppoValueType = {}));
class EppoValue {
    constructor(valueType, boolValue, numericValue, stringValue, objectValue) {
        this.valueType = valueType;
        this.boolValue = boolValue;
        this.numericValue = numericValue;
        this.stringValue = stringValue;
        this.objectValue = objectValue;
    }
    static valueOf(value, valueType) {
        if (value == null) {
            return EppoValue.Null();
        }
        switch (valueType) {
            case interfaces_1.VariationType.BOOLEAN:
                return EppoValue.Bool(value);
            case interfaces_1.VariationType.NUMERIC:
                return EppoValue.Numeric(value);
            case interfaces_1.VariationType.INTEGER:
                return EppoValue.Numeric(value);
            case interfaces_1.VariationType.STRING:
                return EppoValue.String(value);
            case interfaces_1.VariationType.JSON:
                return EppoValue.JSON(value);
            default:
                return EppoValue.String(value);
        }
    }
    toString() {
        switch (this.valueType) {
            case EppoValueType.NullType:
                return 'null';
            case EppoValueType.BoolType:
                return this.boolValue ? 'true' : 'false';
            case EppoValueType.NumericType:
                return this.numericValue ? this.numericValue.toString() : '0';
            case EppoValueType.StringType:
                return this.stringValue ?? '';
            case EppoValueType.JSONType:
                try {
                    return JSON.stringify(this.objectValue) ?? '';
                }
                catch {
                    return this.stringValue ?? '';
                }
        }
    }
    /**
     * Useful when storing or transmitting the entire value,
     * in particular the JsonType, is not desired.
     *
     * @returns MD5 hashed string of the value
     */
    toHashedString() {
        const value = this.toString();
        return (0, obfuscation_1.getMD5Hash)(value);
    }
    static Bool(value) {
        return new EppoValue(EppoValueType.BoolType, value, undefined, undefined, undefined);
    }
    static Numeric(value) {
        return new EppoValue(EppoValueType.NumericType, undefined, value, undefined, undefined);
    }
    static String(value) {
        return new EppoValue(EppoValueType.StringType, undefined, undefined, value, undefined);
    }
    static JSON(value) {
        return new EppoValue(EppoValueType.JSONType, undefined, undefined, undefined, typeof value === 'string' ? JSON.parse(value) : value);
    }
    static Null() {
        return new EppoValue(EppoValueType.NullType, undefined, undefined, undefined, undefined);
    }
}
exports.EppoValue = EppoValue;
//# sourceMappingURL=eppo_value.js.map